import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Incentive, Session, useTranslateIncentiveText } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  incentiveIcon: {
    color: theme.colors.green,
    fontSize: theme.iconSize.large,
    marginRight: theme.marginBase,
  },
  container: {
    ...theme.fonts.caption,
    color: theme.colors.inkPrimary,
    display: 'flex',
    alignItems: 'flex-start',
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.greenMuted,
    padding: theme.marginBase * 2,
  },
}));

interface Props {
  incentive: Incentive;
  session?: Session;
  className?: string;
}

export const IncentiveBlock = ({ incentive, session, className }: Props) => {
  const classes = useStyles();

  const text = useTranslateIncentiveText(
    incentive,
    session?.locale || 'en',
    session,
  );

  return (
    <p className={classnames(classes.container, className)}>
      <i className={classnames('ri-gift-line', classes.incentiveIcon)} />
      {text}
    </p>
  );
};
